import styled from 'styled-components';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';

export const ReviewRowWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: '16px 32px',
  borderBottom: `1px solid ${theme.colors.neutral['200']}`,

  '&:last-of-type': {
    borderBottom: 'none',
  },
}));
